import Vue from "vue";

Vue.component("forms", require("./components/Forms.vue"));
Vue.component("generate", require("./form/Generate.vue"));
Vue.component(
    "caddyreport",
    require("./components/FormSubmissionReportCaddy.vue")
);


//Vue.component('filesUpload', require('../../../../../Modules/FileAttachments/Resources/assets/js/components/FilesUpload.vue'));



// WEBPACK FOOTER //
// ./Modules/OnlineForm/Resources/assets/js/app.js